import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import IClient from '@/interfaces/client';

export function getClients(options: any = {}): Observable<IClient[]> {
  return from(apiClient.get(ENDPOINTS.CLIENTS, { ativo: options.status})).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function getLeanClients(options: any = {}, returnEnderecos:boolean = false, returnEnderecosInativos:boolean = true): Observable<IClient[]> {
  return from(apiClient.get(ENDPOINTS.CLIENTS, { ativo: options.status, lean: true, returnEnderecos: returnEnderecos, returnEnderecosInativos })).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function listClients(ativo: boolean, idsBusinessUnit: number[]): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.CLIENTS + '/combo', {ativo, idsEmpresas: idsBusinessUnit})).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getClient(id: number): Observable<IClient> {
  return from(apiClient.get(`${ENDPOINTS.CLIENTS}/${id}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function saveClient(payload: any): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CLIENTS, payload)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function updateClient(payload): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CLIENTS, payload)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function activateClient(id:number, ativo:boolean): Observable<any> {
  return from(apiClient.put(`${ENDPOINTS.CLIENTS}/${id}/ativacao`, null, { ativo: ativo})).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function deleteClient(id: string): Observable<any[]> {
  return from(apiClient.delete(`${ENDPOINTS.CLIENTS}/${id}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
